import { PayloadAction } from 'interfaces/action'
import { createPayloadAction } from 'helpers/actionsHelpers'
import { Anchor, AnchorActivationOptions, NavigationAppState } from 'interfaces/navigation'
import { extractAllGetParams } from 'helpers/utilsHelpers'

export const ACTIVATE_ANCHOR = 'ACTIVATE_ANCHOR' as const
export type ActivateAnchor = PayloadAction<typeof ACTIVATE_ANCHOR, { to: Anchor | null, options: AnchorActivationOptions }>

const DEFAULT_ANCHOR_OPTIONS: AnchorActivationOptions = {
  behavior: 'instant',
  block: 'start',
  preventScrollWhenVisible: false,
}

// null means discard anchor
export const activateAnchorActionCreator = (to: Anchor | null, options?: Partial<AnchorActivationOptions>): ActivateAnchor => {
  const normalizedOptions = {
    ...DEFAULT_ANCHOR_OPTIONS,
    ...options,
  }

  return createPayloadAction(ACTIVATE_ANCHOR, { to, options: normalizedOptions }) as ActivateAnchor
}

/**
 * @deprecated Resolve your pushes in components via Redirect and NavigationRedirect
 */
export const PUSH = 'PUSH' as const
export type PushAction = PayloadAction<typeof PUSH, NavigationAppState['navigateToUrl']>
export const pushActionCreator = (url: NavigationAppState['navigateToUrl']): PushAction => {
  // console.trace(`pushActionCreator: url: ${ url }`)
  return createPayloadAction(PUSH, url)
}


export const SET_NAVIGATION_PARAMS = 'SET_NAVIGATION_PARAMS' as const
type SetNavigationParams = PayloadAction<typeof SET_NAVIGATION_PARAMS, Record<string, string>>
export const setNavigationTrackingActionCreator = (search: string): SetNavigationParams =>
  createPayloadAction(SET_NAVIGATION_PARAMS, extractAllGetParams(search))

export const RELOAD = 'RELOAD' as const
type ReloadAction = PayloadAction<typeof RELOAD, string | undefined>
export const reloadActionCreator = (url?: string): ReloadAction =>
  createPayloadAction(RELOAD, url)

type Action =
  | ReloadAction
  | ActivateAnchor
  | PushAction
  | SetNavigationParams

export default Action
